import { Search } from "@mui/icons-material";
import {
  IconButton,
  InputAdornment,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import { Box } from "@mui/system";
import dayjs from "dayjs";
import React, { useContext, useState } from "react";
import { TableVirtuoso } from "react-virtuoso";
import { ApplicationContext } from "../../context/application_ctx";
import { font } from "../../styles/font";
import { TextFieldMA } from "../../styles/styledComponents";
import { theme } from "../../styles/theme";
import { IconBack } from "../../svgIcons/icons";
import {
  stringToArray,
} from "../../utility/string";

export const Audit = ({ tableView, setTableView }) => {
  const { auditList } = useContext(ApplicationContext);
  const [searchedEmpQuery, setSearchedEmpQuery] = useState("");
 console.log(auditList,'getauditInside')
//   let auditDetails = [
//     {
//       name: "Rahul Kumar",
//       purchasedOn: "29 December 2024",
//       expiredOn: "29 December 2024",
//       revokedOn: "05 January 2024",
//       switchedFrom: "Trial to Standard",
//     },
//   ];

  let result = auditList?.filter(
    (data, i) =>
      data?.employeeEmail
        ?.toLowerCase()
        ?.includes(searchedEmpQuery) ||
      data?.action?.toLowerCase()?.includes(searchedEmpQuery) ||
      data?.licenseType?.toLowerCase()?.includes(searchedEmpQuery)
  )
  
  return (
    <>
      {/* <Box display='flex'  justifyContent='center' flex='1' flexWrap='nowrap' >

        <Box display='flex'  alignItems='center' flex='1' backgroundColor={theme.col_4} px={4} borderRadius='12px' height='130px'>

        <Box display='flex' flexDirection={'column'} justifyContent='center' gap='5px' >
        <Box display='flex'  alignItems='center'  gap='8px'>
        <Avatar {...stringAvatar('Rahul Kumar')}/>
        <Typography fontSize={font.size.fs_3} color={theme.col_2}>Rahul Kumar</Typography>

        </Box>
        <Box display='flex' flexDirection='column'  justifyContent='center'  gap='5px'>

        <Typography fontSize={font.size.fs_3} color={theme.col_3}>Created at</Typography>
        <Typography fontSize={font.size.fs_3} color={theme.col_3}>Valid upto</Typography>
        </Box>

        </Box>
        <Box display='flex' flexDirection={'column'} justifyContent='center' gap='5px' >

        <Typography fontSize={font.size.fs_3} color={theme.col_3}>Revoked at</Typography>
        <Typography fontSize={font.size.fs_3} color={theme.col_3}> Changed from</Typography>
        </Box>

        </Box>
       
        </Box> */}

      <Box
        display="flex"
        alignItems="center"
        flex="1"
        flexDirection="column"
        backgroundColor={theme.col_4}
        borderRadius="8px"
        border={"1px solid rgb(229, 234, 242)"}
        overflow="hidden"
      >
        <Box width="100%" display="flex" gap="5px" alignItems="center" px={1.4}>
          {tableView ? (
            <Box py={1}>
              <IconButton onClick={() => setTableView(0)}>
                <IconBack />
              </IconButton>
            </Box>
          ) : (
            <></>
          )}
          <TextFieldMA
            id="emp"
            type="search"
            defaultValue={searchedEmpQuery}
            // disabled
            onChange={(e) => setSearchedEmpQuery(e.target.value)}
            size="small"
            fullWidth
            placeholder="Search Employee"
            InputProps={{
              style: {
                border: "none",
              },
              startAdornment: (
                <InputAdornment>
                  <IconButton size="small">
                    <Search />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            sx={{
              background: grey[100],
              borderRadius: "32px",
              "& fieldset": { border: "none" },
              "&.MuiInputBase-formControl": {
                border: "none",
                outline: "none",
              },
            }}
          />
        </Box>
        <Box   display="flex"
        // alignItems="center"
        width='100%'
        flex="1"
        // height='100%'
        flexDirection="column"
        // backgroundColor={theme.col_4}
        borderRadius="8px"
        position='relative'
        backgroundColor='red'
        >

        <TableVirtuoso
                atBottomStateChange={(bottom) => {
                  console.log(bottom,'bottom')
                }}
                  className="scroller"
                //   ref={scrollerAll}
                //   style={{ height: 470 }}
                  data={auditList
                    ?.filter(
                      (data, i) =>
                        data?.employeeEmail
                          ?.toLowerCase()
                          ?.includes(searchedEmpQuery) ||
                        data?.action?.toLowerCase()?.includes(searchedEmpQuery) ||
                        data?.licenseType?.toLowerCase()?.includes(searchedEmpQuery)
                    )}
                  components={TableComponents}
                  fixedHeaderContent={() => (
                    <TableRow
                      sx={{
                        background: theme.col_2_alpha2,
                        color: theme.col_2,
                      }}
                    >
                     
                      <TableCell sx={{ color: theme.col_2,fontWeight:'bold',fontFamily:font.family.fm_2,width:'50%' }}>
                       Name
                      </TableCell>
                      <TableCell
                      align="center"
                        sx={{
                          color: theme.col_2,
                          fontWeight:'bold'
                          ,fontFamily:font.family.fm_2,
                          width:'50%'
                        }}
                      >
                        Message
                      </TableCell>
                    </TableRow>
                  )}
                  itemContent={(i, data, dd) => {
                    // result.push(...Array.of(user));
                    return (
                      <>
                    <TableCell>
                      <Typography display="flex" alignItems="center" gap="12px"  noWrap='wrap'>
                        <Box
                          display="flex"
                          alignItems="center"
                          width="40px"
                          height="40px"
                          borderRadius="50px"
                          flexDirection="column"
                          justifyContent="center"
                          backgroundColor={theme.col_14_alpha}
                        >
                          <Typography
                            fontFamily={font.family.fm_2}
                            fontSize={font.size.fs_3}
                            fontWeight="bold"
                            color={theme.col_3}
                            textTransform="capitalize"
                          >
                            {stringToArray(data?.employeeEmail)}
                          </Typography>
                        </Box>
                        {data?.employeeEmail}
                      </Typography>
                    </TableCell>
                    <TableCell align="center">
                      <Typography display="flex" justifyContent="center">
                        <Typography
                          display="flex"
                          alignItems="center"
                          width="fit-content"
                          sx={{ whiteSpace: "nowrap" }}
                          padding={"2px 8px"}
                          justifyContent="center"
                          height="25px"
                          textTransform="capitalize"
                          borderRadius="25px"
                          color={theme.col_3}
                          fontWeight="bold"
                          backgroundColor={theme.col_14_alpha}
                          fontSize={font.size.fs_4}
                        >
                          {data?.action} {data?.action === 'added' ? 'to' : "from"} {data?.licenseType} on{" "}
                          {dayjs(data?.date).format("DD -  MMMM - YYYY")}
                        </Typography>
                      </Typography>
                    </TableCell>
                
                      </>
                    );
                  }}
                />
                   {auditList?.length === 0 || result?.length === 0 ? (
                <Box
                  display="flex"
                  width="100%"
                  alignItems="center"
                  justifyContent="center"
                  height="100%"
                  flexDirection="column"
                  flex="1"
                  position='absolute'
                >
                  <Box
                    display="flex"
                    width="20%"
                    backgroundColor={theme.col_2_alpha}
                    height="80px"
                    borderRadius="13px"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Typography
                      fontFamily={font.family.fm_2}
                      color={theme.col_2}
                      textAlign="center"
                      fontSize={font.size.fs_5}
                      fontWeight="bold"
                    >
                      No Audit Found
                    </Typography>
                  </Box>
                </Box>
               ) : (
                ""
              )} 
        </Box>
        {/* <TableContainer sx={{ height: "537px",display:'flex',flexDirection:'column' }}>
          <Table className="tableEmployees" stickyHeader>
            <TableHead>
              <TableCell>Name</TableCell>
              <TableCell align="center">Message</TableCell>
            </TableHead>
            <TableBody>
              {auditList
                ?.filter(
                  (data, i) =>
                    data?.employeeEmail
                      ?.toLowerCase()
                      ?.includes(searchedEmpQuery) ||
                    data?.action?.toLowerCase()?.includes(searchedEmpQuery) ||
                    data?.licenseType?.toLowerCase()?.includes(searchedEmpQuery)
                )
                ?.map((data,i ,finalResult) => {
                
                        result?.push(finalResult);
                    return(

                  <TableRow>
                    <TableCell>
                      <Typography display="flex" alignItems="center" gap="12px">
                        <Box
                          display="flex"
                          alignItems="center"
                          width="40px"
                          height="40px"
                          borderRadius="50px"
                          flexDirection="column"
                          justifyContent="center"
                          backgroundColor={theme.col_14_alpha}
                        >
                          <Typography
                            fontFamily={font.family.fm_2}
                            fontSize={font.size.fs_3}
                            fontWeight="bold"
                            color={theme.col_3}
                            textTransform="capitalize"
                          >
                            {stringToArray(data?.employeeEmail)}
                          </Typography>
                        </Box>
                        {data?.employeeEmail}
                      </Typography>
                    </TableCell>
                    <TableCell align="center">
                      <Typography display="flex" justifyContent="center">
                        <Typography
                          display="flex"
                          alignItems="center"
                          width="fit-content"
                          sx={{ whiteSpace: "nowrap" }}
                          padding={"2px 8px"}
                          justifyContent="center"
                          height="25px"
                          textTransform="capitalize"
                          borderRadius="25px"
                          color={theme.col_3}
                          fontWeight="bold"
                          backgroundColor={theme.col_14_alpha}
                          fontSize={font.size.fs_4}
                        >
                          {data?.action} {data?.action === 'added' ? 'to' : "from"} {data?.licenseType} on{" "}
                          {dayjs(data?.date).format("DD -  MMMM - YYYY")}
                        </Typography>
                      </Typography>
                    </TableCell>
                
                  </TableRow>
                    )
})}
            </TableBody>
          </Table>
          {auditList?.length === 0 || result?.length === 0 ? (
                <Box
                  display="flex"
                  width="100%"
                  alignItems="center"
                  justifyContent="center"
                  height="100%"
                  flexDirection="column"
                  flex="1"
                >
                  <Box
                    display="flex"
                    width="20%"
                    backgroundColor={theme.col_2_alpha}
                    height="80px"
                    borderRadius="13px"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Typography
                      fontFamily={font.family.fm_2}
                      color={theme.col_2}
                      textAlign="center"
                      fontSize={font.size.fs_5}
                      fontWeight="bold"
                    >
                      No Audit Found
                    </Typography>
                  </Box>
                </Box>
              ) : (
                ""
              )}
        </TableContainer> */}
      </Box>
    </>
  );
};


const TableComponents = {
    Scroller: React.forwardRef((props, ref) => (
      <TableContainer component={Paper} {...props} ref={ref} />
    )),
    Table: (props) => <Table {...props} style={{ borderCollapse: "separate" }} />,
    TableHead: TableHead,
    TableRow: (props) => <TableRow className="row" {...props} />,
    TableBody: React.forwardRef((props, ref) => (
      <TableBody {...props} ref={ref} />
    )),
  };